<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"> </p-toast>
  <p-confirmDialog
    header="Confirmation"
    icon="pi pi-exclamation-triangle"
  ></p-confirmDialog>

  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent"
    >
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr />
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
            <div
              class="w-100"
            style="
              text-align: center;
              background-color: yellow;
              padding: 5px;
              margin-bottom: 15px;
            "
              >
              <p>
                <b>{{ formAlert }}</b>
              </p>
            </div>
          </div>
        }
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="ownerFirstName" id="ownerFirstName" type="text" pInputText/>
          <label for="ownerFirstName">Owner First Name</label>

          @for (validation of validationMessages.ownerFirstName; track validation) {
            <span>
              @if (form1.get('ownerFirstName').hasError(validation.type) && (form1.get('ownerFirstName').dirty || form1.get('ownerFirstName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="ownerLastName" id="ownerLastName" type="text" pInputText/>
          <label for="ownerLastName">Owner Last Name</label>

          @for (validation of validationMessages.ownerLastName; track validation) {
            <span>
              @if (form1.get('ownerLastName').hasError(validation.type) && (form1.get('ownerLastName').dirty || form1.get('ownerLastName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber  formControlName="targetProformaValue"  inputId="currency-us" [minFractionDigits]="0" mode="currency" currency="USD" locale="en-US">
          </p-inputNumber>
          <label for="targetProformaValue">Target Proforma Value </label>
          @for (validation of validationMessages.targetProformaValue; track validation) {
            <span>
              @if (form1.get('targetProformaValue').hasError(validation.type) && (form1.get('targetProformaValue').dirty || form1.get('targetProformaValue').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <p-inputNumber  formControlName="managementFee" inputId="minmax"
            [min]="0" [max]="100" [minFractionDigits]="0" mode="decimal">
          </p-inputNumber>
          <label for="managementFee">Management Fee %</label>
          @for (validation of validationMessages.managementFee; track validation) {
            <span>
              @if (form1.get('managementFee').hasError(validation.type) && (form1.get('managementFee').dirty || form1.get('managementFee').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="adrDevelopmentName" id="adrDevelopmentName" type="text" pInputText/>
          <label for="adrDevelopmentName">Adr Development Name </label>

          @for (validation of validationMessages.adrDevelopmentName; track validation) {
            <span>
              @if (form1.get('adrDevelopmentName').hasError(validation.type) && (form1.get('adrDevelopmentName').dirty || form1.get('adrDevelopmentName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <label for="para1">PDF Para1 Html</label>
        <span class="p-float-label required-field w-100 mb-3">
          <editor formControlName="para1" id="para1" [init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
          </editor>
          @for (validation of validationMessages.para1; track validation) {
            <span>
              @if (form1.get('para1').hasError(validation.type) && (form1.get('para1').dirty || form1.get('para1').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-12">
        <label for="para2">PDF Para2 Html</label>
        <span class="p-float-label required-field w-100 mb-3">
          <editor formControlName="para2" id="para2" [init]="{
							height: 500,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
          </editor>
          @for (validation of validationMessages.para2; track validation) {
            <span>
              @if (form1.get('para2').hasError(validation.type) && (form1.get('para2').dirty || form1.get('para2').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>
  </div>
  <hr />
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (mktgLetterId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!mktgLetterId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }

          @if (mktgLetterId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3 mb-3">
    <div class="col-lg-4 offset-lg-8">
      <p-table [value]="replacementValues" styleClass="p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th>Key</th>
            <th>Description</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-replacementValue>
          <tr>
            <td class="font-bold">{{replacementValue.key}}</td>
            <td>{{replacementValue.description}}</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="mt-2"><span class="font-bold"> Note: </span> Use this key inside single Brackets "{{ '{}' }}" </div>
    </div>
  </div>
</div>
